import { Directive, ElementRef, NgZone } from '@angular/core';
import { Content, Footer } from 'ionic-angular';
import { ToolsProvider } from '../../providers/tools/tools';
import * as _ from 'lodash';

/**
 * Generated class for the ContentResizeKeyboardDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[content-resize-keyboard]', // Attribute selector
})
export class ContentResizeKeyboardDirective {
  subs = [];

  constructor(
    public element: ElementRef,
    private content: Content,
    public zone: NgZone,
    public tools: ToolsProvider
  ) {
    window['_ContentResizeKeyboardDirective'] = ContentResizeKeyboardDirective;
    window['_ContentResizeKeyboardDirectiveInstance'] = this;

    const resize = () => {
        try {
          const rect =
            this.content._fixedContent.nativeElement.getBoundingClientRect();

          if (rect && rect.width && rect.height) {
            this.content.resize();
          }
        } catch (e) {}
      },
      runResizers = () => {
        resize();
        setTimeout(resize, 100);
        setTimeout(resize, 200);
        setTimeout(resize, 300);
        setTimeout(resize, 400);
        setTimeout(resize, 600);
        setTimeout(resize, 700);
        setTimeout(resize, 800);
        setTimeout(resize, 900);
        setTimeout(resize, 1000);
      };

    this.subs.push(
      this.tools.on('onKeyboardShow', runResizers),
      this.tools.on('onKeyboardDidShow', runResizers),
      this.tools.on('onKeyboardHide', runResizers),
      this.tools.on('onKeyboardDidHide', runResizers)
    );
  }

  ngOnDestroy() {
    _.each(this.subs, s => {
      if (s instanceof Function) {
        s();
      } else if (s.unsubscribe) {
        s.unsubscribe();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/directives/content-resize-keyboard/content-resize-keyboard.ts